/** Default All colors list height before the user resizes it (the old `max-h-48`). */
export const COLOR_LIST_DEFAULT_HEIGHT = 192
/** Shortest the list can be dragged: three rows of 32px swatches. */
export const COLOR_LIST_MIN_HEIGHT = 96

/**
 * Clamps a dragged list height. `contentHeight` caps it at the full list, so there's no empty space
 * below the last row; `roomBelow` is how far the popover can still grow before it reaches the
 * bottom of the live area.
 */
export function clampListHeight(
  desired: number,
  startHeight: number,
  { contentHeight, roomBelow }: { contentHeight: number; roomBelow: number }
): number {
  const max = Math.max(COLOR_LIST_MIN_HEIGHT, Math.min(contentHeight, startHeight + roomBelow))

  return Math.round(Math.min(max, Math.max(COLOR_LIST_MIN_HEIGHT, desired)))
}

/**
 * The tallest the list can render with the whole popover between `top` (the menu bar's bottom
 * edge) and `bottom` (the live area's bottom edge). `chromeHeight` is everything in the popover
 * except the list. Never below the minimum: when even that doesn't fit, the popover overflows the
 * bottom rather than climbing over the menu bar.
 */
export function maxFittingListHeight({
  top,
  bottom,
  chromeHeight,
}: {
  top: number
  bottom: number
  chromeHeight: number
}): number {
  return Math.max(COLOR_LIST_MIN_HEIGHT, Math.floor(bottom - top - chromeHeight))
}
